import React, { useEffect }  from 'react';
import { pick } from 'lodash';
import PropTypes from 'prop-types';
import { Button, Icon, Modal, Form,  AuthorizedDriversList, Input } from '../components';
import { useModal, useForm, useFormValidator } from '../hooks';
import { random } from 'lodash';

const initialFormData = {
  authorized_drivers: [],
  application_promise: ''
}

const rules = {
  authorized_drivers: 'array',
  application_promise: 'required',
}

const authorizedDriverInitialFormData = {
  name: '',
  address: '',
  license_number: '',
  expiry_date: ''
}

const authorizedDriverRules = {
  name: 'required|text_vapt',
  address: 'required',
  license_number: 'required|drivers_license_number',
  expiry_date: 'required'
}

export const options = {
  initialFormData,
  rules
}



const AuthorizedDriversForm = ({ onNext, onPrevious, initialValue }) => {
  
  const [isOpen, onOpen, onClose] = useModal()

  const [value, { onSwitch, onCreateUpdateToList, onSetForm, onDeleteToList }] = useForm(initialFormData)
  const { response, renderMessage } = useFormValidator(value, rules)

  const [authorizedDriverFormData, authorizedDriverAction] = useForm(authorizedDriverInitialFormData)
  const authorizedDriverFormValidator = useFormValidator(authorizedDriverFormData, authorizedDriverRules)

  useEffect(() => {
    onSetForm(pick(initialValue, Object.keys(initialFormData)))
    // authorizedDriverAction.onSetForm(pick(initialValue, Object.keys(authorizedDriverInitialFormData)))
    // eslint-disable-next-line
  }, [Object.values(initialValue).join(',')])

  const handleSubmitAuthorizedDrivers = e => {
    e.preventDefault()
    onCreateUpdateToList({
      target: {
        name: 'authorized_drivers',
        value: {
          id: random(1, 1000),
          ...authorizedDriverFormData
        }
      }
    })
    authorizedDriverAction.onSetForm(authorizedDriverInitialFormData)
    onClose()
  }

  const handleShowModal = e => {
    e.preventDefault()
    onOpen()
  }

  const handleOnEditItem = data => e => {
    e.preventDefault()
    authorizedDriverAction.onSetForm(data)
    onOpen()
  }

  const handleOnDeleteItem = data => {
    onDeleteToList({
      target: {
        name: 'authorized_drivers',
        value: data
      }
    })
    authorizedDriverAction.onSetForm(authorizedDriverInitialFormData)
    onClose()
  }

  return (
    <>
      <div className="my-3">
        <span className="text-success text-sm font-bold ">Authorized Drivers</span>
      </div>
      <div className="p-1">
        
        <AuthorizedDriversList 
          data={value.authorized_drivers}
          onEditItem={handleOnEditItem}
          onDeleteItem={handleOnDeleteItem}
          />
        <div className="flex space-x-2 items-center pt-5">
          <span className="text-sm">Add authorized driver</span>
          {renderMessage('authorized_drivers')}
          <Button className="!w-auto !bg-warning !text-black" onClick={handleShowModal}><Icon.Plus /></Button>
        </div>
      </div>
      <div className="flex space-x-2 items-center">
        <div className="w-2/12 flex"> 
          <Input type="checkbox" name="application_promise" value={value.application_promise} onChange={onSwitch}/>
        </div>
        <p className="my-10">
          Operator undertakes that all information stated in this sheet are true and correct. Any misrepresentation
          and/or unlawful withholding of information will warrant outright denial and/or cancellation of the franchise
          in accordance with the Public Service Act. The Board reserves the right to VERIFY all information in this
          data sheet and to institute appropriate criminal prosecution for any act prejudicial to the public interest.
        </p>
      </div>
      <div className="flex space-x-2 float-right">
        <Button type="button" onClick={onPrevious(value)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button disabled={!response.is_passed} type="button" onClick={onNext(value)} className="!bg-warning !w-auto !text-black">Next</Button>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Form >
          <Form.FormGroup>
            <Input 
              label="Name"
              name="name"
              value={authorizedDriverFormData.name}
              onChange={authorizedDriverAction.onChange}
              helperMessage={authorizedDriverFormValidator.renderMessage}
            />
            <Input 
              label="Address"
              name="address"
              value={authorizedDriverFormData.address}
              onChange={authorizedDriverAction.onChange}
              helperMessage={authorizedDriverFormValidator.renderMessage}
            />
            <Input 
              type="mask"
              mask='a99-99-999999'
              label="Driver's License Number"
              name="license_number"
              placeholder='____-__-______'
              value={authorizedDriverFormData.license_number}
              onChange={authorizedDriverAction.onChange}
              helperMessage={authorizedDriverFormValidator.renderMessage}
            />
            <Input 
              type="date"
              label="Expiry Date"
              name="expiry_date"
              value={authorizedDriverFormData.expiry_date}
              onChange={authorizedDriverAction.onChange}
              helperMessage={authorizedDriverFormValidator.renderMessage}
            />
          </Form.FormGroup>
          <div>
            <Button 
              onClick={handleSubmitAuthorizedDrivers} 
              disabled={!authorizedDriverFormValidator.response.is_passed} 
              type="button" 
              className="!w-auto !bg-warning !text-black float-right">
              {authorizedDriverFormData.id && 'Update'}
              {!authorizedDriverFormData.id && 'Add'}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  )
}

AuthorizedDriversForm.propTypes = {
  onNext: PropTypes.instanceOf(Function).isRequired,
  onPrevious: PropTypes.instanceOf(Function).isRequired,
}

AuthorizedDriversForm.displayName = 'AuthorizedDriversForm'

export default AuthorizedDriversForm